import { Grid } from '@material-ui/core';
import List from '@mui/material/List';
import Typography from '@material-ui/core/Typography';
import ListItem from '@mui/material/ListItem';
import { ExamTaskWithoutRequiredComment } from '../../../services/scoring/scoring.types';

const criteriaListItemStyle = {
  display: 'list-item',
  fontFamily: 'Roboto',
  fontSize: '15px',
  padding: '5px',
};

export const getExamTaskWithoutRequiredCommentSubtext = (
  examTaskWithoutRequiredComments: ExamTaskWithoutRequiredComment[],
) => {
  return (
    <>
      {examTaskWithoutRequiredComments.map((examTaskWithoutRequiredComment) => (
        <div
          key={examTaskWithoutRequiredComment.examTaskName}
          style={{ display: 'flex', width: '100%', justifyContent: 'center' }}
        >
          <Grid item xs={12} key={examTaskWithoutRequiredComment.examTaskName}>
            <Typography
              variant="body1"
              style={{
                fontWeight: 800,
                fontSize: '17px',
                padding: '0px 0px',
                margin: '15px',
              }}
            >
              {`Zadanie ${examTaskWithoutRequiredComment.examTaskName}`}
            </Typography>
            <div style={{ display: 'flex', justifyContent: 'start' }}>
              <List component="div" disablePadding style={{ listStyleType: 'disc' }}>
                {examTaskWithoutRequiredComment.criteriaWithoutRequiredComment.map((criteria) => (
                  <ListItem sx={criteriaListItemStyle} key={criteria.criterionName}>
                    {criteria.criterionName}
                  </ListItem>
                ))}
              </List>
            </div>
          </Grid>
        </div>
      ))}
    </>
  );
};
